import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientListUsecase {
  //MARK: - Constructor
  constructor(private readonly patientRepository: PatientRepository) {}

  async execute(): Promise<SATResult<PatientTableInfoEntity[], SATError>> {
    const result = await this.patientRepository.fetchPatientList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value!);
  }
}
